import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { BenefitYearFilter } from '../../coverage/coverage-filter/BenefitYearFilter';
import { AccountForFilter } from './AccountForFilter';
import Feature from '../../../../../services/feature';

import './index.scss';

export const AccountFilter = ({
  AccountNames,
  AccountChangeHandler,
  ActiveAccountName,
  benefitYearProps,
  benefitYearChangeHandler,
}) => {
  return (
    <>
      <Row className="filter-bar-accounts ml-3">
        <Col md={3} xs={6} className="coverage-for">
          <div className="filter-data">
            <Row className="align-items-center w-100">
              <Col xs={6} sm={5} className="pr-0">
                <p>
                  <span className="">
                    <b>Account: </b>
                  </span>
                </p>
              </Col>
              <Col xs={6} sm={7} className="p-0">
                <AccountForFilter
                  AccountNames={AccountNames}
                  AccountChangeHandler={AccountChangeHandler}
                  ActiveAccountName={ActiveAccountName}
                />
              </Col>
            </Row>
          </div>
        </Col>
        <Feature name="spendingAccount">
          <Col md={5} xs={6} className="coverage-for ml-2 ml-sm-0 ">
            <div className="filter-data">
              <Row className="align-items-center w-100">
                <Col xs={6} sm={3} className="pr-0">
                  <p>
                    <span className="">
                      <b>Benefit Year: </b>
                    </span>
                  </p>
                </Col>
                <Col xs={6} sm={9} className="p-0">
                  <BenefitYearFilter
                    benefitYearProps={benefitYearProps}
                    benefitYearChangeHandler={benefitYearChangeHandler}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Feature>
        {/*<Col md={3} xs={6} className="coverage-type">
          <div className="filter-data">
            <Row className="align-items-center">
              <Col xs={12} sm={5} className="pr-0">
                <p>
                  <span className="d-none d-md-block">
                    <b>Benefit Year: </b>
                  </span>
                  <span className="d-block d-md-none mobile-label">Benefit Year</span>
                </p>
              </Col>
              <Col xs={12} sm={7} className="p-0">
                <YearForFilter {...coverageTypeProps} />
              </Col>
            </Row>
          </div>
        </Col> */}
      </Row>
    </>
  );
};
